function Privacy() {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6 sm:px-12 lg:px-24">
    <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Politique de confidentialité
      </h1>
      <p className="text-sm text-gray-600 mb-8">
        Dernière mise à jour : <strong>13 février 2025</strong>
      </p>

      <section className="space-y-6 text-gray-700 leading-relaxed">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">1. Introduction</h2>
          <p>
            Chez <strong>Moncatalog </strong>, nous proposons des services de formation et de conception d’applications. Nous utilisons également WhatsApp Cloud API pour communiquer avec nos clients, notamment pour :
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Envoyer des rappels sur les sessions de formation.</li>
            <li>Informer sur nos nouvelles formations et produits applicatifs.</li>
            <li>Relancer les clients ayant interagi avec nos publicités.</li>
          </ul>
          <p className="mt-2">
            Nous attachons une grande importance à la protection de vos données personnelles et nous nous engageons à respecter votre vie privée.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">2. Informations collectées</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Données d'identité :</strong> Nom, prénom, numéro de téléphone.</li>
            <li><strong>Données de communication :</strong> Messages échangés sur WhatsApp, vos réponses aux publicités facebook.</li>
            
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">3. Finalités d’utilisation des données</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Vous envoyer des rappels sur les sessions de formation.</li>
            <li>Vous informer sur nos nouvelles formations et produits applicatifs.</li>
            <li>Relancer les clients pour leur proposer nos services.</li>
            <li>Assurer un suivi client et répondre à vos demandes.</li>
            <li>Optimiser nos campagnes publicitaires et améliorer notre relation client.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">4. Partage des données</h2>
          <p>Nous ne vendons pas vos données. Toutefois, elles peuvent être partagées avec :</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li><strong>Meta Platforms, Inc.</strong> (WhatsApp), pour l’utilisation de WhatsApp Cloud API.</li>
            <li><strong>Nos prestataires techniques</strong> qui nous aident à gérer les envois de messages et SMS et la gestion de nos services.</li>
            <li><strong>Les autorités compétentes</strong>, si la loi l’exige.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">5. Sécurité des données</h2>
          <p>
            Nous prenons des mesures techniques et organisationnelles pour protéger vos données contre tout accès non autorisé, perte ou altération.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">6. Conservation des données</h2>
          <p>
            Vos données sont conservées aussi longtemps que nécessaire pour vous fournir nos services et répondre à nos obligations légales.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">7. Vos droits</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Droit d’accès, de rectification et de suppression de vos données.</li>
            <li>Droit de vous opposer à l’utilisation de vos données à des fins de prospection.</li>
            <li>Droit à la limitation du traitement de vos données.</li>
            <li>Droit de retirer votre consentement à tout moment.</li>
          </ul>
          <p className="mt-2">
            Pour exercer vos droits, contactez-nous à <strong>moncatalogg@gmail.com</strong>.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">8. Cookies et traceurs</h2>
          <p>
            Nous pouvons utiliser des cookies et technologies similaires pour améliorer votre expérience sur notre site et optimiser nos campagnes publicitaires.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">9. Modification de la politique</h2>
          <p>
            Cette politique peut être mise à jour. Toute modification sera publiée sur cette page avec la date de mise à jour.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">10. Contact</h2>
          <p>Pour toute question, contactez-nous :</p>
          <ul className="mt-2 space-y-1">
            <li>📧 <strong>moncatalogg@gmail.com / aboousmane@gmail.com</strong></li>
            <li>📍 <strong>Douala Cameroun</strong></li>
          </ul>
        </div>
      </section>
    </div>
  </div>
  );
  }
  
 
  
  export default Privacy;
  